<!--
  Full-bleed overlay: the host is pointer-events:none so the document stays interactive;
  each bar below opts back in with pointer-events:auto.
-->

<!-- Top-center pill — morphs in place between zoom and search states. -->
<div class="fpc-toolbar" [class.fpc-toolbar--search]="searchOpen()">
  @if (!searchOpen()) {
    <div class="fpc-group">
      <button
        dataSelector="file-preview-zoom-out"
        aria-label="Zoom out"
        type="button"
        class="fpc-btn"
        [disabled]="!canZoomOut()"
        (click)="zoomOut.emit()"
      >
        <aiwyn-icon name="minus" [height]="18" [width]="18" />
      </button>
      <button dataSelector="file-preview-zoom-reset" aria-label="Reset zoom" type="button" class="fpc-zoom small-500" (click)="fit.emit()">
        {{ zoomPercent() }}%
      </button>
      <button
        dataSelector="file-preview-zoom-in"
        aria-label="Zoom in"
        type="button"
        class="fpc-btn"
        [disabled]="!canZoomIn()"
        (click)="zoomIn.emit()"
      >
        <aiwyn-icon name="plus" [height]="18" [width]="18" />
      </button>
      @if (canSearch()) {
        <span aria-hidden="true" class="fpc-divider"></span>
        <button dataSelector="file-preview-search-open" aria-label="Search document" type="button" class="fpc-btn" (click)="openSearch()">
          <aiwyn-icon name="search" [height]="18" [width]="18" />
        </button>
      }
    </div>
  } @else {
    <div class="fpc-group fpc-group--search">
      <span aria-hidden="true" class="fpc-search-icon">
        <aiwyn-icon name="search" [height]="18" [width]="18" />
      </span>
      <input
        #searchInput
        dataSelector="file-preview-search-input"
        aria-label="Search document"
        type="text"
        class="fpc-search-input body-400"
        (keydown)="onSearchKeydown($event)"
        (input)="onSearchInput(searchInput.value)"
        placeholder="Search…"
      />
      <span aria-live="polite" class="fpc-search-count small-500">
        @if (hasMatches()) {
          {{ searchCurrent() }} / {{ searchTotal() }}
        } @else {
          0 / 0
        }
      </span>
      <button
        dataSelector="file-preview-search-prev"
        aria-label="Previous match"
        type="button"
        class="fpc-btn"
        [disabled]="!hasMatches()"
        (click)="prevMatch.emit()"
      >
        <aiwyn-icon name="chevron-up" [height]="18" [width]="18" />
      </button>
      <button
        dataSelector="file-preview-search-next"
        aria-label="Next match"
        type="button"
        class="fpc-btn"
        [disabled]="!hasMatches()"
        (click)="nextMatch.emit()"
      >
        <aiwyn-icon name="chevron-down" [height]="18" [width]="18" />
      </button>
      <span aria-hidden="true" class="fpc-divider"></span>
      <button dataSelector="file-preview-search-close" aria-label="Close search" type="button" class="fpc-btn" (click)="closeSearch()">
        <aiwyn-icon name="x" [height]="18" [width]="18" />
      </button>
    </div>
  }
</div>

<!-- Left / right circular page navigation, hugging the canvas edges. -->
<button
  dataSelector="file-preview-page-prev"
  aria-label="Previous page"
  type="button"
  class="fpc-page-nav fpc-page-nav--prev"
  [disabled]="atFirstPage()"
  (click)="prevPage.emit()"
>
  <aiwyn-icon name="chevron-left" [height]="22" [width]="22" />
</button>
<button
  dataSelector="file-preview-page-next"
  aria-label="Next page"
  type="button"
  class="fpc-page-nav fpc-page-nav--next"
  [disabled]="atLastPage()"
  (click)="nextPage.emit()"
>
  <aiwyn-icon name="chevron-right" [height]="22" [width]="22" />
</button>

<!-- Bottom-center page pill: read-only-looking until clicked, then a jump-to-page input. -->
<div class="fpc-page-pill">
  @if (!jumpEditing()) {
    <button
      dataSelector="file-preview-page-jump"
      aria-label="Go to page"
      type="button"
      class="fpc-page-label small-500"
      (click)="openJump()"
    >
      {{ currentPage() }} of {{ pageCount() }}
    </button>
  } @else {
    <input
      #pageInput
      dataSelector="file-preview-page-input"
      aria-label="Go to page"
      type="number"
      class="fpc-page-input small-500"
      [max]="pageCount()"
      [value]="currentPage()"
      (blur)="commitJump(pageInput.value)"
      (keydown)="onJumpKeydown($event, pageInput.value)"
      min="1"
    />
    <span class="fpc-page-total small-500">of {{ pageCount() }}</span>
  }
</div>
